import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, refreshList } from "../../../redux/features/modalSlice";
import { successToast, errorToast } from "../../../Utils/toast";
import { ContactUsChangeStatus } from "../../../redux/services/EnquriesService/enquries.Services";

function EditEnquiry({ data, isVendor = false, onSuccess }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const defaultStatuses = [
    { value: "new", label: "New" },
    { value: "contacted", label: "Contacted" },
    { value: "closed", label: "Closed" },
  ];

  const statusOptions = data?.statusOptions?.length
    ? data.statusOptions
    : defaultStatuses;

  const [status, setStatus] = useState("");
  const [adminRemark, setAdminRemark] = useState("");

  // ✅ data prop se prefill
  useEffect(() => {
    if (data) {
      setStatus(data.status || statusOptions[0]?.value);
      setAdminRemark(data.admin_remark || "");
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!status) {
      errorToast("Please select a status");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        id: data?.id || data?._id,
        status,
        admin_remark: adminRemark,
        is_vendor: isVendor, 
      };

      const res = await ContactUsChangeStatus(payload);

      if (res?.success !== false) {
        successToast(res?.message || "Enquiry updated successfully");

        if (onSuccess) await onSuccess(); 
        dispatch(refreshList());
        dispatch(closeModal());  
      } else {
        errorToast(res?.message || "Failed to update enquiry");
      }
    } catch (err) {
      console.error("Update Enquiry Error:", err);
      errorToast(err?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">
      <form onSubmit={handleSubmit} className="row">

        {/* Status */}
        <div className="col-md-12 mb-3">
          <label className="form-label">
            Status <span className="text-danger">*</span>
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">-- Select Status --</option>
            {statusOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {/* Admin Remark */}
        <div className="col-md-12 mb-3">
          <label className="form-label">Admin Remark</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Enter remark (optional)"
            value={adminRemark}
            onChange={(e) => setAdminRemark(e.target.value)}
          />
        </div>

        {/* Submit */}
        <div className="col-md-12 text-end">
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={() => dispatch(closeModal())}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button type="submit" className="add-btn" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Enquiry"}
          </button>
        </div>

      </form>
    </div>
  );
}

export default EditEnquiry;